import React, { Dispatch, SetStateAction } from 'react';

export interface ContextData {
  quoteId: string | null;
  agentId: string | null;
  publicId: string | null;
  experience: string | null;
  experiments: Record<string, string>;
}

export interface AnalyticsContextType {
  eventPrefix: string;
  context: ContextData;
  setContext: Dispatch<SetStateAction<ContextData>>;
}

const defaultContext = {
  eventPrefix: '',
  context: {
    quoteId: null,
    agentId: null,
    publicId: null,
    experience: null,
    experiments: {},
  },
  setContext: () => {},
};

const AnalyticsContext = React.createContext<AnalyticsContextType>(defaultContext);

export default AnalyticsContext;
